import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import styled from 'styled-components';
import loadImg from '../assets/image/load/x.gif';
const Loading = () => (_jsxs(LoadIngContainer, { className: "loading-wrapper", children: [_jsxs("div", { className: "loading", children: [_jsxs("div", { className: "bulletouter", children: [_jsx("div", { className: "bulletinner" }), _jsx("div", { className: "mask" }), _jsx("div", { className: "dot" })] }), _jsx("p", { children: "loading!" })] }), _jsx("img", { src: loadImg, alt: "" })] }));
export default Loading;
const LoadIngContainer = styled.div `
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  >img{
    width: 80rem;
    height: 80rem;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall `
     >img{
    width: 40rem;
    height: 40rem;
  }
  `};
`;
